import { CircleGauge, GitCompareArrows, MapPin, MoveUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useCompare } from "../../contexts/CompareContext";
import { VerificationBadges } from "./VerificationBadges";

export const MachineCard = ({ machine }) => {
  const { items, toggle } = useCompare();
  const selected = items.some((item) => item.id === machine.id);
  const image = machine.media?.find((item) => item.type === "image")?.url;

  return (
    <article className="group flex h-full flex-col overflow-hidden border border-slate-700 bg-slate-900" data-testid={`machine-card-${machine.id}`}>
      <Link to={`/machine/${machine.slug || machine.id}`} className="relative aspect-[4/3] overflow-hidden bg-slate-800" data-testid={`machine-image-link-${machine.id}`}>
        <img src={image} alt={machine.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" loading="lazy" />
        <div className="absolute left-3 top-3"><VerificationBadges machine={machine} compact /></div>
        <span className="absolute bottom-3 left-3 bg-slate-950/90 px-2 py-1 text-[10px] font-bold uppercase text-white">{machine.condition_type || machine.condition}</span>
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="text-xs font-bold uppercase text-orange-400">{machine.manufacturer} · {machine.year}</div>
        <Link to={`/machine/${machine.slug || machine.id}`} data-testid={`machine-title-link-${machine.id}`}>
          <h3 className="mt-2 font-head text-xl font-bold uppercase leading-tight text-white group-hover:text-orange-400">{machine.title}</h3>
        </Link>
        <div className="mt-3 flex items-center gap-2 text-sm text-slate-400"><MapPin className="h-4 w-4 text-orange-400" /> {machine.location}</div>
        <div className="mt-5 border-t border-slate-800 pt-4">
          <div className="flex items-center gap-2 text-sm font-bold uppercase text-emerald-400" data-testid={`machine-working-status-${machine.id}`}><CircleGauge className="h-4 w-4" />{machine.working_status || "Working status documented"}</div>
          <div className="mt-4 flex gap-2">
            <button onClick={() => toggle(machine)} className={`grid h-10 w-10 place-items-center border transition-colors ${selected ? "border-orange-500 bg-orange-500 text-white" : "border-slate-600 text-slate-300 hover:border-orange-500"}`} aria-label="Compare machine" data-testid={`compare-toggle-${machine.id}`}>
              <GitCompareArrows className="h-4 w-4" />
            </button>
            <Link to={`/machine/${machine.slug || machine.id}`} className="inline-flex h-10 flex-1 items-center justify-center gap-2 bg-orange-500 px-4 text-sm font-bold uppercase text-white hover:bg-orange-600" data-testid={`view-machine-${machine.id}`}>
              View machine <MoveUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
};